module.exports = __webpack_public_path__ + "img/4.dd77cc9a.png";